export default __webpack_public_path__ + "static/media/tiger_media_logo_colored.c011ce7a.png";